import moment from "moment";
import { mapState } from "vuex";
import http from "../../store/modules/helpers/httpInterceptor";
import {
  DATE_FORMAT_FULL,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  DURATION_TYPES,
  EXPLANATION_NOT_REFUND,
  EXPLANATION_REFUND_BY_DAY,
  EXPLANATION_REFUND_BY_HOUR,
  EXPLANATION_REQUEST_TYPE,
  FOLDER_NAME_ABNORMAL,
  FOLDER_NAME_LEAVE_REQUEST,
  LEAVE_REQUEST_TYPE,
  MORNING_TYPE,
  MULTIPLY_TYPE,
  REASON_WORK_OUTSIDE,
  REQUEST_EXPLANATION,
  REQUEST_TIME_OFF,
  REQUEST_TYPES,
  REQUEST_TYPE_HOUR,
  REQUEST_TYPE_SHIFT,
  REQUEST_WORK_OUTSIDE,
  SINGLE_TYPE,
  WORK_OUTSIDE_REQUEST_TYPE,
  AFTERNOON_TYPE,
  DATE_FORMAT_HMS,
  MATERNITY_LEAVE_TYPE,
  WORKING_TIME_ONSIDE_REQUEST
} from "../commons/commonConstant";
import {
  beforeUploadFile,
  disableWeekendCommon,
  downloadFile,
  getHoursWorkingDay,
  getInfoStaff,
  getMessages,
  toFixedNumber,
} from "../commons/commons";

const errorRequestDate = {
  date: "Request date is required",
  duration: "Duration is required",
  hour: "Hour is required",
  minute: "Minute is required",
};
import { ref } from 'vue'
export default {
  name: "RequestModal",
  props: {
    dataRecord: {
      type: Object,
      default: function () {
        return {};
      },
    },
    visibleModal: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    handleCancel: Function,
    getData: Function,
    type: String,
    requestTypeLog: {
      type: String,
      default: REQUEST_TYPE_HOUR,
    },
    explanationTypeLog: {
      type: String,
      default: EXPLANATION_REFUND_BY_HOUR,
    },
    requestTypeDay: {
      type: String,
      default: REQUEST_TYPE_HOUR,
    },
    explanationTypeDay: {
      type: String,
      default: EXPLANATION_REFUND_BY_HOUR,
    },
    dataRequestDefaults: {
      type: Object,
      default: function () {
        return {};
      },
    },
    fromPage: {
      type: String,
      default: "Request",
    },
    dateRequest: {
      type: Object,
    },
  },
  setup() {
    const selectReasonType = ref()

    return {
      selectReasonType
    }
  },
  data() {
    return {
      formRQ: this.$form.createForm(this, {
        name: "formRQ",
        onValuesChange: this.onValuesChange,
      }),
      REQUEST_TYPES,
      REQUEST_TYPE_DEFAULT: "LEAVE_REQUEST",
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 },
      },
      formData: {},
      dataRequests: [],
      requestList: [],
      reasonList: [],
      isExplanation: false,
      durations: {
        duration: null,
        startTime: null,
        endTime: null,
      },
      isFlexible: false,
      isTimeOff: false,
      fileList: [],
      fetching: false,
      approver: {},
      disabledStartShift: true,
      disabledEndShift: true,
      visibleBalances: false,
      remain_day: null,
      timeout: null,
      requestLogModal: this.requestTypeLog,
      explanationLogModal: this.explanationTypeLog,
      REQUEST_TYPE_SHIFT,
      REQUEST_TYPE_HOUR,
      DURATION_TYPES,
      EXPLANATION_REFUND_BY_HOUR,
      EXPLANATION_REFUND_BY_DAY,
      EXPLANATION_NOT_REFUND,
      requestHours: [],
      isLoading: false,
      folderName: FOLDER_NAME_LEAVE_REQUEST,
      editRequestFlexible: false,
      MULTIPLY_TYPE,
      SINGLE_TYPE,
      errorMessage: "HRMS does not support you create work outside request. Please log ticket in PMS System",
      WORK_OUTSIDE_REQUEST_TYPE,
      errorHour: "",
      errorMinute: "",
      requestMinutes: [],
      LEAVE_REQUEST_TYPE,
      isShowRequestTable: false,
      isMaternityLeave: false,
      isOnsiteRequest: false,
      isOnsiteRequestDataChanged: false,
      reasonType: "",
      MATERNITY_LEAVE_TYPE,
      WORKING_TIME_ONSIDE_REQUEST
    };
  },
  watch: {
    dataDurationTime() {
      const { dataDurationTime } = this;
      if (dataDurationTime) {
        this.durations = {
          duration: dataDurationTime?.quantity_in_days ?? 0,
          startTime: dataDurationTime?.start_time
            ? moment(dataDurationTime?.start_time, DATE_FORMAT_FULL).format("HH:mm")
            : "",
          endTime: dataDurationTime?.end_time
            ? moment(dataDurationTime?.end_time, DATE_FORMAT_FULL).format("HH:mm")
            : "",
        };
      }
    },
  },
  computed: {
    ...mapState({
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      employeeList: (state) => state.application.employeeList,
      userInfo: (state) => state.user.userInfo,
      dataRequestSelections: (state) => state.request.dataRequestSelections,
      lastTimesheet: (state) => state.application.lastTimesheet,
      dataActualFixed: (state) => state.abnormalcase.dataActualFixed,
      dataDurationTime: (state) => state.request.dataDurationTime,
      approverUser: (state) => state.application.approverUser,
      timeServer: (state) => state.application.timeServer,
      balanceEmployee: (state) => state.filters.balanceEmployee,
    }),
    requestTypes() {
      return REQUEST_TYPES.filter((requestType) => {
        return requestType?.type.includes(this.type) || (this.isEdit && this.isOnsiteRequest && requestType?.code === WORK_OUTSIDE_REQUEST_TYPE);
      });
    },
  },
  async created() {
    // Get Actual
    this.$store.dispatch("abnormalcase/getActualOfFixed");

    // Get balance employee
    await this.$store.dispatch("filters/getBalanceEmployee", { employeeId: this.userInfo.userId });

    // Get Approver User Login
    this.getApproverUser(this.userInfo.userName);

    // Get Time Server
    this.$store.dispatch("application/getTimeServer");

    if (this.dataRequestSelections) {
      this.requestList = this.dataRequestSelections?.data?.request_reason;
      this.requestAllList = this.dataRequestSelections?.data?.request_reason;
      if (this.isEdit) {
        await this.handleInfoRequest();
      } else {
        if (this.type === SINGLE_TYPE) {
          this.getRequestListByRequestType(this.REQUEST_TYPE_DEFAULT);
        } else {
          this.getRequestListByRequestType(null, MULTIPLY_TYPE);
          this.getReasonListByRequest(REQUEST_TIME_OFF);
        }
      }
    }

    if (!this.isEdit) {
      if (this.type === SINGLE_TYPE) {
        this.formData = {
          request_type: this.REQUEST_TYPE_DEFAULT,
          request: REQUEST_TIME_OFF,
        };
        this.getReasonListByRequest(REQUEST_TIME_OFF);
        if (this.requestTypeLog === REQUEST_TYPE_HOUR) {
          this.isShowRequestTable = true;
        }
      } else {
        this.formData = {
          request_type: LEAVE_REQUEST_TYPE,
          request: REQUEST_TIME_OFF,
        };
        this.isShowRequestTable = true;
      }
    }

    // Handle initial form from page TimeSheet
    if (this.fromPage === "TimeSheet" && this.requestLogModal === REQUEST_TYPE_SHIFT) {
      this.formData = { ...this.formData, start_date: this.dateRequest };
    }

    if (this.fromPage === "TimeSheet" && !this.isEdit) {
      this.handleDateRequestDefault();
    }

    if (!this.isEdit) {
      // this.selectReasonType.value = "ANN_LEAVE_CORP"
      this.formRQ.setFieldsValue({
        ["reason_type"]: "ANN_LEAVE_CORP"
      });
      let { balanceEmployee } = this;
        this.remain_day = {
          day: toFixedNumber(balanceEmployee?.remain_annual_leave, 3) ?? 0,
          hours: toFixedNumber(balanceEmployee?.annual_leave_balance_hours, 3) ?? 0,
        };
    }
  },
  methods: {
    moment,
    getInfoStaff,
    disabledReasonType() {
      const { type, formData, formRQ } = this;
      if (type === SINGLE_TYPE) {
        return !(type === SINGLE_TYPE && (formRQ.getFieldValue("request") || formData.request))
         || (this.isEdit && (this.isMaternityLeave || this.isOnsiteRequest));
      } else {
        return (
          type === MULTIPLY_TYPE &&
          !formRQ.getFieldValue("staff_id") &&
          (formData.request_type === LEAVE_REQUEST_TYPE || formRQ.getFieldValue("request_type") === LEAVE_REQUEST_TYPE)
        );
      }
    },
    getMinutesSelect(requestHours, hour) {
      const hourFind = requestHours?.find((item) => item.value === hour);
      if (hourFind) return hourFind?.children ?? [];
      return [];
    },
    handleDateRequestDefault() {
      this.dataRequests.push({
        index: Date.now(),
        requestDate: this.dateRequest,
        duration: undefined,
        requestTypeLog: REQUEST_TYPE_SHIFT,
        isDisableDuration: true,
        requestHours: [],
        hour: undefined,
        minute: undefined,
        errorDate: "",
        errorDuration: "",
        errorHour: "",
        errorMinute: "",
      });
      this.onChangeDateInTableRequest(this.dateRequest, 0);
    },
    // Handle when edit request
    async handleInfoRequest() {
      const {
        id,
        request_type,
        reason_type,
        salary,
        quantity_in_hours,
        shift,
        start_date,
        end_date,
        start_shift,
        end_shift,
        description,
        mail_cc,
        mail,
        absent_time,
        leaving_type,
        is_flexible,
        quantity_in_minutes,
        employee
      } = this.dataRecord;
      this.editRequestFlexible = is_flexible;
      this.isMaternityLeave = reason_type === MATERNITY_LEAVE_TYPE;
      this.isOnsiteRequest = reason_type === WORKING_TIME_ONSIDE_REQUEST;
      this.formData = {
        ...this.formData,
        request_type:
          request_type === REQUEST_TIME_OFF
            ? LEAVE_REQUEST_TYPE
            : request_type === REQUEST_EXPLANATION
            ? EXPLANATION_REQUEST_TYPE
            : WORK_OUTSIDE_REQUEST_TYPE,
        request: request_type,
        reason_type,
        salary,
        request_date: start_date,
        request_hours: parseFloat(quantity_in_hours) ? parseFloat(quantity_in_hours) : 0,
        hour: Math.trunc(quantity_in_minutes / 60) ?? 0,
        minute: quantity_in_minutes % 60 ?? 0,
        duration: shift,
        start_date: start_date ? moment(start_date, DATE_FORMAT_SHORT) : undefined,
        end_date: end_date ? moment(end_date, DATE_FORMAT_SHORT) : undefined,
        start_shift,
        end_shift,
        description,
        staff: this.userInfo.displayName,
        date: start_date ? moment(start_date, DATE_FORMAT_SHORT) : undefined,
        ccMails: mail_cc,
        absent_time: absent_time,
        actual: leaving_type,
        maternity_leave_start_date: start_date ? moment(start_date, DATE_FORMAT_SHORT) : undefined,
        maternity_leave_end_date: end_date ? moment(end_date, DATE_FORMAT_SHORT) : undefined,
        staff_list: employee?.user_name
      };
      this.reasonType = reason_type;
      if (mail && mail.length > 0) {
        const uniqueUsers = new Set(mail?.map((user) => user.user_name));
        this.onSearchStaff([...uniqueUsers].join(","));
      }
      this.getAllListFile(id);
      this.getReasonListByRequest(request_type);
      if (request_type === REQUEST_EXPLANATION) {
        this.isExplanation = true;
        this.$store
          .dispatch("application/getAbsentData", {
            userId: this.userInfo.userId,
            date: start_date,
          })
          .then((res) => {
            const { absentTime, remainExplanationTime, refundHoursPerExplanation } = res;
            this.formData = {
              ...this.formData,
              absent_time: absentTime ?? "--",
              balances: `${remainExplanationTime} times` ?? "--",
              explain_hour: `${refundHoursPerExplanation} hour(s)`,
            };
          })
          .catch((error) => {
            this.$message.error(error.response.data.message);
          });
      } else {
        this.requestLogModal = shift ? REQUEST_TYPE_SHIFT : REQUEST_TYPE_HOUR;
        if (this.requestLogModal === REQUEST_TYPE_HOUR) {
          await this.getRequestHours(moment(start_date, DATE_FORMAT_SHORT));
          this.requestMinutes = this.getMinutesSelect(this.requestHours, this.formData.hour);
        }
        // await this.getBalanceEmployee(this.userInfo.userId);
        this.getRemainDay(request_type, reason_type, true);
        this.isExplanation = false;
        this.disabledStartShift = false;
        this.disabledEndShift = false;
      }
      if (this.isOnsiteRequest) {
        this.getDurationTime({
          start_date: start_date ? moment(start_date, DATE_FORMAT_SHORT) : undefined,
          end_date: end_date ? moment(end_date, DATE_FORMAT_SHORT) : undefined,
          start_shift,
          end_shift
        });
      }
    },
    getRequestListByRequestType(requestType, type) {
      if (this.requestAllList) {
        if (type === MULTIPLY_TYPE) {
          this.requestList = this.requestAllList.filter(
            (request) =>
              request.request_type_code === REQUEST_WORK_OUTSIDE || request.request_type_code === REQUEST_TIME_OFF
          );
        } else {
          if (requestType === LEAVE_REQUEST_TYPE) {
            this.requestList = this.requestAllList.filter((request) => request.request_type_code === REQUEST_TIME_OFF);
          } else if (requestType === EXPLANATION_REQUEST_TYPE) {
            this.requestList = this.requestAllList.filter(
              (request) => request.request_type_code === REQUEST_EXPLANATION
            );
          } else if (requestType === WORK_OUTSIDE_REQUEST_TYPE) {
            this.requestList = this.requestAllList.filter(
              (request) => request.request_type_code === REQUEST_WORK_OUTSIDE
            );
          }
        }
      } else {
        this.requestList = [];
      }
    },
    getReasonListByRequest(requestCode) {
      const request = this.requestAllList?.find((request) => request.request_type_code === requestCode);
      if (!request) {
        this.reasonList = [];
      } else {
        if (requestCode === REQUEST_WORK_OUTSIDE) {
          if (this.type === MULTIPLY_TYPE) {
            this.reasonList =
              request && request.reasons?.filter((reason) => reason.reason_type_code !== REASON_WORK_OUTSIDE);
          } else {
            this.reasonList =
              request && request.reasons?.filter((reason) => reason.reason_type_code === WORKING_TIME_ONSIDE_REQUEST);
          }
        } else {
          this.reasonList = request && request.reasons;
        }
      }
    },
    onValuesChange(_, values) {
      const { type } = this;
      const { request_type, request, reason_type, request_date, hour } = values;
      if (request_type) {
        this.formRQ.resetFields();
        this.getRequestListByRequestType(request_type);
        this.visibleBalances = false;
        if (request_type === LEAVE_REQUEST_TYPE) {
          this.formRQ.setFieldsValue({
            request: REQUEST_TIME_OFF,
          });
          if (type === MULTIPLY_TYPE) {
            this.isShowRequestTable = true;
          }

          this.formData = {
            reason_request: undefined,
          };
          if (this.fromPage === "TimeSheet") {
            this.handleDateRequestDefault();
          }
          this.isExplanation = false;
          this.isTimeOff = true;
        } else if (request_type === EXPLANATION_REQUEST_TYPE) {
          this.request_type = FOLDER_NAME_ABNORMAL;
          this.isExplanation = true;
          this.dataRequests = [];
          this.formData = {
            staff: this.userInfo.displayName,
            reason_type: "NOT_ENOUGH_WORKING_HOURS",
            balances: "--",
            absent_time: "--",
            explain_hour: "0 hour(s)",
            date: this.dateRequest,
          };
          this.handleChangeDateExplanation(this.dateRequest);
          this.formRQ.setFieldsValue({
            request: REQUEST_EXPLANATION,
          });
        } else if (request_type === WORK_OUTSIDE_REQUEST_TYPE) {
          this.formRQ.setFieldsValue({
            request: REQUEST_WORK_OUTSIDE,
          });
          if (this.fromPage === "TimeSheet") {
            this.handleDateRequestDefault();
          }
          this.formData = {
            reason_request: undefined,
          };
          this.isExplanation = false;
          this.isTimeOff = true;
          // this.$message.error(this.errorMessage);
          if (type === MULTIPLY_TYPE) {
            this.isShowRequestTable = false;
          }
        }
      }
      if (request) {
        this.visibleBalances = false;
        this.formRQ.setFieldsValue({
          reason_type: undefined,
          salary: undefined,
          description: "",
          ccMails: [],
        });
        this.requestLogModal = this.requestTypeDay;
        this.dataRequests = [];
        this.getReasonListByRequest(request);
      }
      if (reason_type) {
        const request = this.formRQ.getFieldValue("request");
        this.getRemainDay(request, reason_type, false);
        this.isMaternityLeave = reason_type === MATERNITY_LEAVE_TYPE;
        this.isOnsiteRequest = reason_type === WORKING_TIME_ONSIDE_REQUEST;
        this.formData = {
          ...this.formData,
          isDisableDuration: true,
          requestHours: [],
          errorDateFrom: "",
          errorDateTo: "",
        };
      }
      if (request_date) {
        this.handleChangeRequestDateEdit(request_date);
        this.formData = { ...this.formData, hour: undefined, minute: undefined, duration: undefined };
      }

      if (hour !== undefined) {
        this.requestMinutes = this.getMinutesSelect(this.requestHours, hour);
        this.formRQ.setFieldsValue({ minute: undefined });
      }
    },
    onChangeStaffHRLog(staff_id) {
      this.formRQ.setFieldsValue({ staff_id });
      if (staff_id) {
        this.$store.dispatch("filters/getBalanceEmployee", { employeeId: staff_id });
        this.formRQ.setFieldsValue({ reason_type: undefined });
        this.dataRequests = [];
        this.remain_day = null;
      } else {
        this.dataRequests = [];
      }
    },
    async handleChangeRequestDateEdit(date) {
      const res = await this.getWorkScheduleUser(date);
      const { request_type } = res;
      this.requestLogModal = request_type;
      if (request_type === REQUEST_TYPE_HOUR) {
        this.getRequestHours(date);
      }
    },
    async getRequestHours(date) {
      const res = await this.getWorkScheduleUser(date);
      const { standard_working_time, request_type, minimum_minute_block_request } = res;
      if (request_type === REQUEST_TYPE_HOUR) {
        this.requestHours = getHoursWorkingDay(standard_working_time, minimum_minute_block_request ?? 30);
      }
    },
    getRemainDay(request, reason_type, isOpenFormEdit) {
      const reason = this.reasonList.find((reason) => reason.reason_type_code === reason_type);
      if (!isOpenFormEdit) {
        this.formRQ.setFieldsValue({ salary: reason.salary });
      } else {
        this.formData = { ...this.formData, salary: reason.salary };
      }
      this.checkVisibleBalances(reason_type);
      if (request === REQUEST_TIME_OFF) {
        let { balanceEmployee } = this;
        if (reason_type === "ANN_LEAVE_CORP") {
          this.remain_day = {
            day: toFixedNumber(balanceEmployee?.remain_annual_leave, 3) ?? 0,
            hours: toFixedNumber(balanceEmployee?.annual_leave_balance_hours, 3) ?? 0,
          };
        } else if (reason_type === "LOA_CORP_11") {
          this.remain_day = {
            day: toFixedNumber(balanceEmployee?.remainOffsetLeave, 3) ?? 0,
          };
        } else if (reason_type === "BIRTHDAY_LEAVE") {
          this.remain_day = {
            day: toFixedNumber(balanceEmployee?.remain_birthday_leave, 3) ?? 0,
          };
        } else {
          this.remain_day = null;
        }
      }
    },
    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      if (value && value !== "" && value.length >= 3) {
        this.fetching = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$store
            .dispatch("application/getEmployeeList", cloneVal)
            .then(() => {
              this.fetching = false;
            })
            .catch(() => {
              this.fetching = false;
            });
        }, timeout);
      }
    },
    checkVisibleBalances(value) {
      this.visibleBalances = value === "BIRTHDAY_LEAVE" || value === "LOA_CORP_11" || value === "ANN_LEAVE_CORP";
    },
    disableWeekends(date) {
      const day = new Date(date).getDay();
      if (this.type === MULTIPLY_TYPE && !this.isMaternityLeave) {
        return day === 0 || day === 6;
      }
      return (
        day === 0 ||
        day === 6 ||
        disableWeekendCommon(
          date.format(DATE_FORMAT_SHORT),
          this.lastTimesheet?.last_timesheet_period_end_date,
          10,
          DATE_FORMAT_SHORT,
          this.timeServer
        )
      );
    },
    disableEditOnsiteRequest(type) {
      if (type === "start") {
        this.disabledStartShift = this.isEdit && this.isOnsiteRequest && 
        disableWeekendCommon(
          this.formData.start_date?.format(DATE_FORMAT_SHORT),
          this.lastTimesheet?.last_timesheet_period_end_date,
          10,
          DATE_FORMAT_SHORT,
          this.timeServer
        );
        return this.disabledStartShift;
      } else if (type === "end") {
        this.disabledEndShift = this.isEdit && this.isOnsiteRequest && 
        disableWeekendCommon(
          this.formData.end_date?.format(DATE_FORMAT_SHORT),
          this.lastTimesheet?.last_timesheet_period_end_date,
          10,
          DATE_FORMAT_SHORT,
          this.timeServer
        );
        return this.disabledEndShift;
      } else {
        return this.isEdit && this.isOnsiteRequest;
      }
    },
    // Xử lý bảng
    addNewRequest() {
      const result = this.validateDataRequest();
      if (result) {
        this.dataRequests.push({
          index: Date.now(),
          requestDate: undefined,
          requestTypeLog: REQUEST_TYPE_SHIFT,
          isDisableDuration: true,
          requestHours: [],
          duration: undefined,
          hour: undefined,
          minute: undefined,
          errorDate: "",
          errorHour: "",
          errorMinute: "",
        });
      }
    },
    remove(request) {
      const dataNews = this.dataRequests.filter((data) => data.index !== request.index);
      this.dataRequests = dataNews;
    },
    validateDataRequest() {
      const { dataRequests } = this;
      const length = dataRequests.length;
      let check = true;
      if (dataRequests && length > 0) {
        for (let i = 0; i < length; i++) {
          if (!dataRequests[i].requestDate) {
            this.dataRequests[i].errorDate = errorRequestDate.date;
            check = false;
            break;
          } else if (dataRequests[i].requestTypeLog === REQUEST_TYPE_HOUR && dataRequests[i].hour === undefined) {
            this.dataRequests[i].errorHour = errorRequestDate.hour;
            check = false;
            break;
          } else if (dataRequests[i].requestTypeLog === REQUEST_TYPE_HOUR && dataRequests[i].minute === undefined) {
            this.dataRequests[i].errorMinute = errorRequestDate.minute;
            check = false;
            break;
          } else if (dataRequests[i].requestTypeLog === REQUEST_TYPE_SHIFT && !dataRequests[i].duration) {
            this.dataRequests[i].errorDuration = errorRequestDate.duration;
            check = false;
            break;
          }
        }
      }

      const { maternity_leave_start_date, maternity_leave_end_date, reason_type } = this.formRQ.getFieldsValue([
        "maternity_leave_start_date",
        "maternity_leave_end_date",
        "reason_type"
      ]);
      
      if (reason_type === MATERNITY_LEAVE_TYPE) {
        if (!maternity_leave_start_date) {
          this.formData.errorDateFrom = errorRequestDate.date;
          check = false;
        } else if (!maternity_leave_end_date) {
          this.formData.errorDateTo = errorRequestDate.date;
          check = false;
        }
      }

      this.dataRequests = [...this.dataRequests];

      return check;
    },

    async onChangeDateInTableRequest(date, index) {
      this.dataRequests[index].hour = undefined;
      this.dataRequests[index].minute = undefined;
      this.dataRequests[index].duration = undefined;
      this.dataRequests[index].requestHours = [];
      this.dataRequests[index].errDate = "";
      this.dataRequests[index].errorDuration = "";
      this.dataRequests[index].errorHour = "";
      this.dataRequests[index].errorMinute = "";

      const { userInfo, type, formRQ } = this;
      if (date) {
        let userId = userInfo.userId;
        if (type === MULTIPLY_TYPE && formRQ.getFieldValue("request_type") === LEAVE_REQUEST_TYPE) {
          const userIdStaff = formRQ.getFieldValue("staff_id");
          if (!userIdStaff) {
            formRQ.setFields({
              staff_id: {
                errors: [
                  {
                    message: "Staff is required!",
                  },
                ],
              },
            });
            return;
          }
          userId = userIdStaff;
        }
        this.dataRequests[index].errorDate = "";
        this.dataRequests[index].requestDate = date;

        const res = await this.getWorkScheduleUser(date, userId);
        const { standard_working_time, request_type, minimum_minute_block_request } = res;
        this.dataRequests[index].requestTypeLog = request_type;
        this.dataRequests[index].isDisableDuration = false;
        if (request_type === REQUEST_TYPE_HOUR) {
          const requestHours = getHoursWorkingDay(standard_working_time, minimum_minute_block_request ?? 30);
          this.dataRequests[index].requestHours = requestHours;
        }
      } else {
        this.dataRequests[index].requestDate = undefined;
        this.dataRequests[index].isDisableDuration = true;
        this.dataRequests[index].errorDate = errorRequestDate.date;
      }
    },

    onChangeDurationInTableRequest(value, index, type) {
      this.dataRequests[index][type] = value;
      if (type === "hour") {
        this.dataRequests[index].minute = undefined;
      }
      switch (type) {
        case "duration": {
          this.dataRequests[index].errorDuration = "";
          return;
        }
        case "hour": {
          this.dataRequests[index].errorHour = "";
          return;
        }
        case "minute": {
          this.dataRequests[index].errorMinute = "";
          return;
        }
      }
    },

    //Xử lý change
    async handleChangeDate(value, type) {
      const { start_date, end_date, start_shift, end_shift } = this.formRQ.getFieldsValue([
        "start_date",
        "end_date",
        "start_shift",
        "end_shift",
      ]);

      if (type === "start") {
        this.formRQ.setFieldsValue({
          start_date: value,
        });
        const { type, isEdit } = this;

        if (type === SINGLE_TYPE && !isEdit) {
          const res = await this.getWorkScheduleUser(value);
          const { request_type } = res;
          this.requestLogModal = request_type;
          if (request_type === REQUEST_TYPE_HOUR) {
            this.isShowRequestTable = true;
            this.dataRequests.push({
              index: Date.now(),
              requestDate: value.startOf("day"),
              duration: undefined,
              requestTypeLog: REQUEST_TYPE_HOUR,
              isDisableDuration: false,
              requestHours: [],
              hour: undefined,
              minute: undefined,
            });
            this.onChangeDateInTableRequest(value, 0);
          }
        }

        if (!end_date || value.startOf("day").isAfter(moment(end_date).startOf("day"))) {
          this.formRQ.setFieldsValue({
            end_date: value,
          });
          this.disabledStartShift = false;
          this.disabledEndShift = false;
        } else if (value.startOf("day").isSame(moment(end_date).startOf("day"))) {
          if (start_shift === AFTERNOON_TYPE && end_shift === MORNING_TYPE) {
            this.formRQ.setFieldsValue({ start_shift: MORNING_TYPE });
          }
        }
      } else {
        this.formRQ.setFieldsValue({
          end_date: value,
        });

        if (!start_date || value.startOf("day").isBefore(moment(start_date).startOf("day"))) {
          this.formRQ.setFieldsValue({
            start_date: value,
          });
          this.disabledStartShift = false;
          this.disabledEndShift = false;
        } else if (value.startOf("day").isSame(moment(start_date).startOf("day"))) {
          if (start_shift === AFTERNOON_TYPE && end_shift === MORNING_TYPE) {
            this.formRQ.setFieldsValue({ start_shift: MORNING_TYPE });
          }
        }
      }
      this.getDurationTime(this.payLoadGetDuration());
      this.isOnsiteRequestDataChanged = this.isChanged();
    },

    async handleChangeMaternityLeaveDate(value, type) {
      const { maternity_leave_start_date, maternity_leave_end_date } = this.formRQ.getFieldsValue([
        "maternity_leave_start_date",
        "maternity_leave_end_date",
      ]);

      if (type === "start") {
        this.formRQ.setFieldsValue({
          maternity_leave_start_date: value,
        });

        if (!maternity_leave_end_date || value.startOf("day").isAfter(moment(maternity_leave_end_date).startOf("day"))) {
          this.formRQ.setFieldsValue({
            maternity_leave_end_date: value,
          });
        }
      } else {
        this.formRQ.setFieldsValue({
          maternity_leave_end_date: value,
        });

        if (!maternity_leave_start_date || value.startOf("day").isBefore(moment(maternity_leave_start_date).startOf("day"))) {
          this.formRQ.setFieldsValue({
            maternity_leave_start_date: value,
          });
        }
      }
    },

    handleShift(value, type) {
      const { start_date, end_date } = this.formRQ.getFieldsValue(["start_date", "end_date"]);
      if (!start_date || !end_date) {
        this.$message.error("Date is required");
      } else {
        if (moment(start_date).startOf("day").isSame(end_date.startOf("day"))) {
          if (type === "start") {
            this.formRQ.setFieldsValue({ start_shift: value });
            if (value === AFTERNOON_TYPE) {
              this.formRQ.setFieldsValue({ end_shift: AFTERNOON_TYPE });
            }
          } else {
            this.formRQ.setFieldsValue({ end_shift: value });
            if (value === MORNING_TYPE) {
              this.formRQ.setFieldsValue({ start_shift: MORNING_TYPE });
            }
          }
        } else {
          this.formRQ.setFieldsValue(type === "start" ? { start_shift: value } : { end_shift: value });
        }
        this.getDurationTime(this.payLoadGetDuration());
        this.isOnsiteRequestDataChanged = this.isChanged();
      }
    },
    payLoadGetDuration() {
      return this.formRQ.getFieldsValue(["start_date", "end_date", "start_shift", "end_shift"]);
    },
    getDurationTime(values) {
      const { start_date, end_date, start_shift, end_shift } = values;
      if (start_date && end_date && start_shift && end_shift) {
        this.$store
          .dispatch("request/getDurationTime", {
            start_date: start_date.startOf("day").format(DATE_FORMAT_FULL),
            end_date: end_date.startOf("day").format(DATE_FORMAT_FULL),
            start_shift,
            end_shift,
          })
          .catch((err) => {
            this.$message.error(err.response.data.message, 5);
          });
      }
    },

    onChangeDate(value) {
      this.formData.abnormal_date = value;
    },

    onChangeStartTime(value) {
      if (
        moment(moment(value).format(DATE_FORMAT_HMS), DATE_FORMAT_HMS).isAfter(
          moment(moment(this.formRQ.getFieldValue("end_time")).format(DATE_FORMAT_HMS), DATE_FORMAT_HMS)
        )
      ) {
        this.formRQ.setFieldsValue({ end_time: value });
      }
    },
    onChangeEndTime(value) {
      if (
        moment(moment(value).format(DATE_FORMAT_HMS), DATE_FORMAT_HMS).isBefore(
          moment(moment(this.formRQ.getFieldValue("start_time")).format(DATE_FORMAT_HMS), DATE_FORMAT_HMS)
        )
      ) {
        this.formRQ.setFieldsValue({ start_time: value });
      }
    },
    // Handle Form Explanation
    async handleChangeDateExplanation(date) {
      if (date) {
        const res = await this.getWorkScheduleUser(date);
        const { explanation_type } = res;
        this.explanationLogModal = explanation_type || EXPLANATION_NOT_REFUND;
        this.$store
          .dispatch("application/getAbsentData", {
            userId: this.userInfo.userId,
            date: date.format(DATE_FORMAT_SHORT),
          })
          .then((res) => {
            const { absentTime, remainExplanationTime, refundHoursPerExplanation } = res;
            this.formRQ.setFieldsValue({
              absent_time: absentTime ?? "--",
              explain_hour: `${refundHoursPerExplanation} hour(s)`,
            });
            this.formData.balances = `${remainExplanationTime} times` ?? "--";
          })
          .catch((error) => {
            this.$message.error(error.response.data.message);
          });
      }
    },
    onOK() {
      this.formRQ.validateFields((err, values) => {
        if (err) return;
        let check = true;
        const { isShowRequestTable, isEdit, dataRequests } = this;
        const { request_type, reason_type } = this.formRQ.getFieldsValue();
        if (isShowRequestTable && !isEdit && request_type === LEAVE_REQUEST_TYPE) {
          if (dataRequests.length === 0 && reason_type !== MATERNITY_LEAVE_TYPE) {
            check = false;
            this.$message.error("Request dates is required");
          } else {
            check = this.validateDataRequest();
          }
        }
        if (!check) return;
        this.handleAPI(values);
      });
    },
    handleAPI(values) {
      const {
        request,
        request_type,
        reason_type,
        request_date,
        date,
        duration,
        request_hours,
        hour,
        minute,
        start_date,
        end_date,
        start_shift,
        end_shift,
        staff_list,
        description,
        actual,
        ccMails,
        staff_id,
        maternity_leave_start_date,
        maternity_leave_end_date,
      } = values;
      if ((!this.fileList || this.fileList.length === 0) && request === REQUEST_WORK_OUTSIDE) {
        this.$message.error("File is required");
      } else {
        const { type, requestLogModal, isEdit, editRequestFlexible, isShowRequestTable } = this;
        let payload = {
          request_type: request,
          reason_type: reason_type,
          description: description ? description.trim() : "",
          mail_cc: ccMails ?? [],
          employee: this.userInfo.userId ?? "",
          start_date: moment(start_date ?? new Date())
            .startOf("day")
            .format(DATE_FORMAT_FULL),
          end_date: moment(end_date ?? new Date())
            .startOf("day")
            .format(DATE_FORMAT_FULL),
          quantity_in_hours: request_hours,
          request_dates: this.dataRequests?.map((data) => {
            if (data.requestTypeLog === REQUEST_TYPE_HOUR) {
              return {
                request_date: data?.requestDate?.startOf("day").format(DATE_FORMAT_FULL),
                request_minutes: data?.hour * 60 + data?.minute,
              };
            } else
              return {
                request_date: data?.requestDate?.startOf("day").format(DATE_FORMAT_FULL),
                duration: data?.duration,
              };
          }),
          start_shift: start_shift,
          end_shift: end_shift,
          dateExplanation: date?.startOf("day").format(DATE_FORMAT_FULL),
          leaving_type: actual,
          time_leave: requestLogModal === REQUEST_TYPE_HOUR ? hour * 60 + minute : duration,
          staff_id,
        };

        if ((type === MULTIPLY_TYPE && request_type === WORK_OUTSIDE_REQUEST_TYPE) || this.disableEditOnsiteRequest()) {
          payload.usernames = staff_list.split(",").map((item) => item.trim());
        }
        if (isEdit && editRequestFlexible) {
          payload = {
            ...payload,
            start_date: moment(request_date ?? new Date())
              .startOf("day")
              .format(DATE_FORMAT_FULL),
            end_date: moment(request_date ?? new Date())
              .startOf("day")
              .format(DATE_FORMAT_FULL),
          };
        }
        if (request === REQUEST_EXPLANATION) {
          delete payload?.start_date;
          delete payload?.end_date;
          delete payload?.request_dates;
        }
        if (!isEdit && requestLogModal === REQUEST_TYPE_HOUR && type === SINGLE_TYPE) {
          delete payload?.start_date;
          delete payload?.end_date;
        }
        if (reason_type === MATERNITY_LEAVE_TYPE) {
          payload = {
            ...payload,
            start_date: moment(maternity_leave_start_date ?? new Date()).startOf("day").format(DATE_FORMAT_FULL),
            end_date: moment(maternity_leave_end_date ?? new Date()).startOf("day").format(DATE_FORMAT_FULL),
          };
        }
        this.isLoading = true;
        if (!isEdit) {
          if (!isShowRequestTable && !this.isExplanation && type === SINGLE_TYPE) {
            this.$store
              .dispatch("request/createRequest", payload)
              .then((res) => {
                this.checkUpdateCreate(res);
              })
              .catch((error) => {
                this.checkUpdateCreate(error.response.data);
              });
          } else if (type === MULTIPLY_TYPE) {
            this.$store
              .dispatch("request/createBatchRequest", payload)
              .then((res) => {
                this.checkUpdateCreate(res);
              })
              .catch((error) => {
                this.checkUpdateCreate(error.response.data);
              });
          } else {
            this.$store
              .dispatch("request/createCommonRequest", payload)
              .then((res) => {
                this.checkUpdateCreate(res, true);
              })
              .catch((error) => {
                this.checkUpdateCreate(error.response.data);
              });
          }
        } else {
          payload.id = this.dataRecord?.id;
          if (!this.editRequestFlexible) {
            this.$store
              .dispatch("request/updateRequest", payload)
              .then((res) => {
                this.checkUpdateCreate(res);
              })
              .catch((error) => {
                this.checkUpdateCreate(error.response.data);
              });
          } else {
            var data = this.formRQ.getFieldsValue()
            payload.request_dates = [
              {
                request_date: data?.request_date?.startOf("day").format(DATE_FORMAT_FULL),
                request_minutes: data?.hour * 60 + data?.minute,
              }
            ]
            this.$store
              .dispatch("request/editCommonRequest", payload)
              .then((res) => {
                this.checkUpdateCreate(res, true);
              })
              .catch((error) => {
                this.checkUpdateCreate(error.response.data);
              });
          }
        }
      }
    },
    checkUpdateCreate(res, type) {
      if (this.type === MULTIPLY_TYPE && this.formRQ.getFieldValue("request_type") === WORK_OUTSIDE_REQUEST_TYPE) {
        let success = false;
        const { messages, response } = res;
        messages?.forEach((msg) => {
          this.$message.error(msg, 5);
        });
        response &&
          response.length > 0 &&
          response.forEach((item) => {
            if (parseInt(item.code) === 200 || parseInt(item.code) === 201) {
              success = true;
              getMessages(item?.messages ?? item?.message).forEach((msg) => {
                this.$message.success(msg, 5);
              });
              this.handleUpload(item?.id);
            } else {
              getMessages(item?.message ?? item?.messages).forEach((msg) => {
                this.$message.error(msg, 5);
              });
            }
          });
        if (success) {
          this.getData();
          this.onCancel();
        } else {
          this.isLoading = false;
        }
      } else {
        if (parseInt(res.code) === 201 || parseInt(res.code) === 200) {
          getMessages(res?.messages ?? res?.message).forEach((msg) => {
            this.$message.success(msg);
          });
          if (type) {
            if (res?.data) {
              res.data?.map((id) => {
                this.handleUpload(id);
              });
            }
          } else {
            this.handleUpload(res?.id);
          }
          this.getData();
          this.onCancel();
        } else {
          this.isLoading = false;
          getMessages(res?.messages ?? res?.message).forEach((msg) => {
            this.$message.error(msg);
          });
        }
      }
    },
    onCancel() {
      this.handleCancel();
      this.formRQ.resetFields();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    deleteFile(id, name) {
      http
        .get(`/tms/request-management/${this.folderName}/${id}/delete-file?name=` + name)
        .then((res) => {
          this.$message.success(res.data);
          if (this.fileList.length > 0) {
            this.isVariableToDownLoad = true;
          } else {
            this.isVariableToDownLoad = false;
          }
          return res.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    beforeUpload(file) {
      const result = beforeUploadFile(file);
      if (result.isValid) {
        this.fileList = [...this.fileList, file];

        if (this.fileList.map((e) => e.size).reduce((partialSum, a) => partialSum + a, 0) > 5242880) {
          this.$message.error("Maximum allowed file size is 5.0 MB", 5);
          this.handleRemove(file);
        }
      } else {
        this.$message.error(result.message, 5);
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.deleteFile(this.dataRecord?.id, file.name);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleDownload() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.$emit("click");
        const { fileList } = this;
        fileList.forEach((file) => {
          http
            .get(`/tms/request-management/${this.folderName}/${this.formData.id}/download?name=` + file.name, {
              responseType: "blob",
            })
            .then((res) => {
              downloadFile(res.data, file.name);
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        });
      }, 500);
    },
    handleUpload(id) {
      const { fileList } = this;
      if (fileList && fileList.length > 0 && id) {
        const formData = new FormData();
        fileList.forEach((file) => {
          formData.append("file", file);
        });
        http
          .post(`/tms/request-management/${this.folderName}/${id}/upload?file`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$message.success("Success");
            fileList.splice(0, fileList.length);
            return res.data;
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    getAllListFile(id) {
      const { fileList } = this;
      http
        .get(`/tms/request-management/${this.folderName}/get-all-file-list?id=` + id)
        .then((res) => {
          if (res.data) {
            let tempData = res.data;
            tempData.forEach((record) => {
              fileList.push(record);
            });
            if (fileList.length > 0) {
              this.isVariableToDownLoad = true;
            } else {
              this.isVariableToDownLoad = false;
            }
            return tempData;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getWorkScheduleUser(date, userId = this.userInfo.userId) {
      return this.$store
        .dispatch("application/getWorkScheduleTypeUser", {
          userId,
          date: date.format(DATE_FORMAT_SHORT),
          type: this.reasonType
        })
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
    getApproverUser(userName) {
      if (userName) {
        this.$store.dispatch("application/getApproverUser", {
          userName,
          date: moment(new Date()).format(DATE_FORMAT_V2),
        });
      }
    },
    async onChangeType(value) {
      this.reasonType = value
      this.isMaternityLeave = value === MATERNITY_LEAVE_TYPE;
      this.isOnsiteRequest = value === WORKING_TIME_ONSIDE_REQUEST;

      if (this.isMaternityLeave) {
        this.dataRequests = [];
      } else if (this.isEdit && this.formRQ.getFieldValue("request_date")) {
        this.getRequestHours(this.formRQ.getFieldValue("request_date"))
        this.formRQ.setFieldsValue({ hour: undefined });
        this.formRQ.setFieldsValue({ minute: undefined });
      } else {
        for (let index = 0; index < this.dataRequests.length; index++) {
          //reset hour & minutes
          this.dataRequests[index].minute = undefined;
          this.dataRequests[index].hour = undefined;
  
          //set hour & minutes by reason_type
          const { userInfo, type, formRQ } = this;
          let userId = userInfo.userId;
          if (type === MULTIPLY_TYPE && formRQ.getFieldValue("request_type") === LEAVE_REQUEST_TYPE) {
            const userIdStaff = formRQ.getFieldValue("staff_id");
            if (!userIdStaff) {
              formRQ.setFields({
                staff_id: {
                  errors: [
                    {
                      message: "Staff is required!",
                    },
                  ],
                },
              });
              return;
            }
            userId = userIdStaff;
          }
  
          const res = await this.getWorkScheduleUser(this.dataRequests[index].requestDate, userId);
          const { standard_working_time, request_type, minimum_minute_block_request } = res;
          this.dataRequests[index].requestTypeLog = request_type;
          this.dataRequests[index].isDisableDuration = false;
          if (request_type === REQUEST_TYPE_HOUR) {
            const requestHours = getHoursWorkingDay(standard_working_time, minimum_minute_block_request ?? 30);
            this.dataRequests[index].requestHours = requestHours;
          }
        }
      }
    },
    isChanged() {
      const { dataRecord } = this;
      const { start_date, end_date, start_shift, end_shift } = this.formRQ.getFieldsValue([
        "start_date",
        "end_date",
        "start_shift",
        "end_shift",
      ]);

      return start_date.format(DATE_FORMAT_SHORT) !== dataRecord?.start_date 
      || end_date.format(DATE_FORMAT_SHORT) !== dataRecord?.end_date
      || start_shift !== dataRecord?.start_shift
      || end_shift !== dataRecord?.end_shift;
    },
  },
};
